﻿
import * as defLib from "./def";

export function isInEnum<T extends Record<string, string | number>>(enumType: T, enumValue: unknown): boolean {
  return Object.values(enumType).includes(enumValue as T[keyof T]);
}
export function enumCast<T extends Record<string, string | number>>(
  enumType: T,
  arg: any,
  def?: T[keyof T]
): T[keyof T] | undefined
{
    return defLib.enumCast(enumType,arg,def);
}
